<!-- 镇级大屏 -->
<template>
  <div id="data-view">
    <dv-full-screen-container :style="'background-image: url('+bgImage+');'">
      <top-header />
      <!--      <dv-border-box-11 title="智能化管护平台" :titleWidth="400"></dv-border-box-11>-->
      <div
        v-if="$route.meta.rank == 2"
        style="height: calc(100% -  100px)"
      >
        <div class="main">
          <!-- 左侧区域 -->
          <div class="main-left">
            <div class="charts-space">
              <dv-border-box-8>
                <div style="padding-top: 5px; padding-left: 10px;">{{listTitle + bcBtnTitle}}
                  <el-button
                    size="mini"
                    type="primary"
                    style="height: 25px; margin-left: 20px;"
                    @click="changeDataType('all', dataClass)"
                  >全部</el-button>
                  <el-button
                    size="mini"
                    type="primary"
                    style="height: 25px;"
                    @click="changeDataType('month', dataClass)"
                  >当月</el-button>
                  <el-button
                    size="mini"
                    type="primary"
                    style="height: 25px;"
                    @click="changeDataType('day', dataClass)"
                  >当日</el-button>
                  <el-button
                    size="mini"
                    type="warning"
                    style="height: 25px;"
                    @click="changeDataClass('bc')"
                  >报抽</el-button>
                  <el-button
                    size="mini"
                    type="warning"
                    style="height: 25px;"
                    @click="changeDataClass('bx')"
                  >报修</el-button>
                </div>
<!--                <dv-scroll-board
                  :config="dataClass==='bc'?bcConfig:bxConfig"
                  style="width:98%; height: calc(100% - 40px); margin-left: 1%; margin-top: 5px;"
                  @click="listCellClick"
                /> -->
                <!-- 手动滚动 -->
                       <el-table
                            :data="bcsddata"
                            class="border-table"
                            style="width:98%; margin-left: 1%; margin-top: 5px;"
                            height=" calc(100% - 40px)"
                            :header-row-style="getRowClass" :header-cell-style="getRowClass"
                            :row-class-name="tabRowClassName"
                            @row-click="listCellClickn"
                            size='mini'
                            >
                            <el-table-column
                              prop="name"
                              label="村居"
                              align="center"
                              width="150"
                             >
                            </el-table-column>
                           <el-table-column
                             prop="gchsNumbers"
                             label="改厕户数"
                              align="center"
                            >
                           </el-table-column>
                          <el-table-column
                            prop="rwslNumbers"
                            label="任务数量"
                             align="center"
                           >
                          </el-table-column>
                          <el-table-column
                            prop="wcNumbers"
                            label="完成数量"
                             align="center"
                           >
                          </el-table-column>
                          <el-table-column
                            prop="csNumbers"
                            label="超时任务"
                             align="center"
                           >
                          </el-table-column>
                          </el-table>

                  </dv-border-box-8>

              </dv-border-box-8>
            </div>
          </div>
          <!-- 中间区域 -->
          <div class="main-middle">
            <el-row>
              <digital-flop ref="flop" />
            </el-row>
            <div class="map-space" style="margin-top: 10px;">
              <dv-decoration-12 />
<!--              <div-->
<!--                id="allmap"-->
<!--                style="height: 100%"-->
<!--              ></div>-->
            </div>
          </div>
          <!-- 右侧区域 -->
          <div class="main-right">
            <div style="height: 45%;">
              <dv-border-box-8>
                <div style="padding-top: 5px; padding-left: 10px;">车辆管控</div>
                <dv-scroll-board
                  :config="clConfig"
                  style="width:98%; height: calc(100% - 40px); margin-left: 1%; margin-top: 5px;"
                />
                <!-- 手动滚动 -->
            <!--           <el-table
                            :data="bxsddata"
                            class="border-table"
                            style="width:98%; margin-left: 1%; margin-top: 5px;"
                            height=" calc(100% - 40px)"
                            :header-row-style="getRowClass" :header-cell-style="getRowClass"
                            :row-class-name="tabRowClassName"
                            @row-click="bxCellClickn"
                            size='mini'
                            >
                            <el-table-column
                              prop="name"
                              label="乡镇"
                              align="center"
                             >
                            </el-table-column>
                           <el-table-column
                             prop="gchsNumbers"
                             label="改厕户数"
                              align="center"
                            >
                           </el-table-column>
                          <el-table-column
                            prop="rwslNumbers"
                            label="任务数量"
                             align="center"
                           >
                          </el-table-column>
                          <el-table-column
                            prop="wcNumbers"
                            label="完成数量"
                             align="center"
                           >
                          </el-table-column>
                          <el-table-column
                            prop="csNumbers"
                            label="超时任务"
                             align="center"
                           >
                          </el-table-column>
                          </el-table>

 -->


              </dv-border-box-8>

           </div>
            <div style="height: 45%; margin-top: 20px;">
              <dv-border-box-8>
                <div style="padding-top: 5px; padding-left: 10px;">满意度</div>
                <div style="width: 50%; height: calc(100% - 30px); float: left;">
                  <div
                    id="bxmyd-pie1"
                    style="width: 100%; height: 80%;"
                  ></div>
                  <div class="zName">报抽</div>
                </div>
                <div style="width: 50%; height: calc(100% - 30px); float: left;">
                  <div
                    id="bxmyd-pie2"
                    style="width: 100%; height: 80%;"
                  ></div>
                  <div class="zName">报修</div>
                </div>
              </dv-border-box-8>
            </div>
          </div>
        </div>
        <div style="height: 35%;display: flex;">
          <div style="width: 65%; height: 100%;">
            <dv-border-box-8>
              <div style="padding-top: 5px; padding-left: 10px;">{{barTitle}}
                <el-button
                  size="mini"
                  type="primary"
                  style="height: 25px; margin-left: 20px;"
                  @click="changeBarType('bc')"
                >报抽</el-button>
                <el-button
                  size="mini"
                  type="primary"
                  style="height: 25px;"
                  @click="changeBarType('bx')"
                >报修</el-button>
              </div>
              <div
                id="myd-echarts"
                class="cc-echarts"
              ></div>
            </dv-border-box-8>
          </div>
          <div style=" width: 35%;height: 100%;">
            <dv-border-box-8>
              <div style="padding-top: 5px; padding-left: 10px;">报警信息
                <el-button
                  size="mini"
                  type="primary"
                  style="height: 25px; margin-left: 20px;"
                  @click="openMap()"
                >地图跟踪</el-button>
                <el-button
                  size="mini"
                  type="primary"
                  style="height: 25px; margin-left: 20px;"
                  @click="toJK()"
                >监控跳转</el-button>
              </div>
              <dv-scroll-board
                :config="config"
                style="width: 98%; height: 99%; margin-left: 1%; margin-top: 5px;"
                @click="cellClick"
              />
            </dv-border-box-8>
          </div>
        </div>

      </div>
      <div v-else>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
    </dv-full-screen-container>
    <el-dialog
      title="预警信息"
      :visible.sync="showState"
      center
      :destroy-on-close="true"
    >
      <LockVideoWindow
        :data.sync="RowData"
        :show.sync="showState"
      ></LockVideoWindow>
    </el-dialog>
    <el-dialog
      title="地图跟踪"
      :visible.sync="mapVisible"
      width="90%"
      center
      :destroy-on-close="true"
    >
      <PrefectureCarMap :mapShow.sync="mapVisible"></PrefectureCarMap>
    </el-dialog>
  </div>
</template>

<script>
import topHeader from '../../components/dataV/topHeader'
import digitalFlop from '../../components/dataV/digitalFlop'
import custom_map_config from '../../assets/css/custom_map_config'
import feidongxian from '../../assets/fdx.json'
import LockVideoWindow from '@/components/LockVideoWindow'
import PrefectureCarMap from '@/components/PrefectureCarMap'
import { mapGetters } from 'vuex'
export default {
    name: 'PrefectureScreenXZ',
    components: { topHeader, digitalFlop, LockVideoWindow, PrefectureCarMap },
    data() {
        return {
            mapVisible: false,
            showState: false,
            bcsddata:[],
            bxsddata:[],
            RowData: {},
            option: null,
            bgImage: require('../../assets/image/bg.png'),
            ccType: '1',
            // 乡镇
            townCode: '',
            // 村庄
            villageCode: '',
            // 所有乡镇
            allTowns: [],
            // 乡镇对应村庄
            allVillages: new Map(),
            ccAllData: [],
            ccMonthData: [],
            ccDayData: [],
            wxAllData: [],
            wxMonthData: [],
            wxDayData: [],
            bcMydData: [],
            bxMydData: [],
            bcBarData: [],
            bxBarData: [],
            listTitle: '报抽数据',
            dataClass: 'bc', // 报抽报修滚动列表切换
            bcBtnTitle: '(全部)',
            bxBtnTitle: '(全部)',
            barTitle: '报抽',
            bcBarTitle: [],
            bxBarTitle: [],
            barFlag: false,
            mydTitle: [],
            chartTypeCCAll: 'bar',
            bcbxflag: [
                { name: '已抽', val: '1' },
                { name: '未抽', val: '2' },
                { name: '已修', val: '3' },
                { name: '未修', val: '4' },
            ],
            numData: {
                bcAll: '', // 报抽数量
                ycAll: '', // 已抽数量
                bxAll: '', // 报修数量
                yxAll: '', // 已修数量
            },
            userInfo: localStorage.getItem('gcUserInfo')
                ? JSON.parse(localStorage.getItem('gcUserInfo'))
                : null,
            baiduMap: null,
            baiduBMap: null,
            infoBox: null,
            map: {
                center: { lng: 117.575857, lat: 32.003189 },
                zoom: 10,
                show: true,
                dragging: true,
            },
            maker: [
                {
                    center: { lng: 117.575858, lat: 32.003189 },
                    zoom: 10,
                    show: true,
                    dragging: true,
                    msg: '海客谈瀛洲',
                },
            ],
            boundary: null,
            mapObj: null,
            bcConfig: {
                header: [
                    '村居',
                    '改厕户数',
                    '任务数量',
                    '完成数量',
                    '超时任务',
                ],
                data: [],
                align: ['center', 'center', 'center', 'center', 'center'],
                columnWidth: [150],
                rowNum: 8,
            },
            bxConfig: {
                header: [
                    '村居',
                    '改厕户数',
                    '任务数量',
                    '完成数量',
                    '超时任务',
                ],
                data: [],
                align: ['center', 'center', 'center', 'center', 'center'],
                columnWidth: [150],
                rowNum: 8,
            },
            clConfig: {
                header: [
                    '司机',
                    '手机号',
                    '车牌号',
                    '任务数量',
                    '完成数量',
                    '报警次数',
                ],
                data: [['李云龙', '皖A1234', '13212456123', '48', '45', '2']],
                align: [
                    'center',
                    'center',
                    'center',
                    'center',
                    'center',
                    'center',
                ],
            },
            config: {
                header: ['车牌号', '所属乡镇', '司机姓名', '联系电话', '时间'],
                data: [],
                align: ['center', 'center', 'center', 'center', 'center'],
            },
            xzList: [],
            mapData: this.GLOBAL.mapData.xzGps,
            bcfw: '', // 报抽钻透当月1 当日2
            bxfw: '', // 报修钻透当月1 当日2
        }
    },
    mounted() {
        let _this = this
        this.getAllData()
        this.getClInfo()
        this.getBcData('')
        this.getBxData('')
        this.getMydData()
        // setTimeout(function () {
        //     _this.createMap()
        // }, 1000)
        this.$parent.getQddGps()
        this.$parent.getWarningList()
    },
    created() {},
    methods: {
      tabRowClassName({row,rowIndex}){
                let index = rowIndex + 1;
            	if(index %2 == 0){
            	    return 'warning-row'
            	}else{
                return 'info-row'
              }
      },
             getRowClass({ row, column, rowIndex, columnIndex }) {
                            return "background:#409EFF; color:#ffffff; "
                        },
        openMap: function () {
            this.mapVisible = true
        },
        // 跳转监控
        toJK: function () {
            let user = this.userInfo.dpUser
            let pwd = this.userInfo.dpPwd
            open(
                'http://124.70.206.40:8081/ChromeClient?user=' +
                    user +
                    '&pass=' +
                    pwd,
                '_blank'
            )
        },
        createMap() {
            let _this = this
            // 获取登录账号所属区划信息
            let ssqhmc = this.userInfo ? this.userInfo.ssqhmc : '肥东县'
            // 默认地图中心点坐标为肥东县
            let lng = 117.575858
            let lat = 32.003189
            if (ssqhmc && ssqhmc != '肥东县') {
                ssqhmc = ssqhmc.replace('肥东县', '')
                this.mapData.forEach((item) => {
                    if (item.name === ssqhmc) {
                        lng = item.longitude
                        lat = item.latitude
                    }
                })
            }
            // 百度地图API功能
            this.baiduMap = new BMap.Map('allmap')
            let point = new BMap.Point(lng, lat)
            this.baiduMap.centerAndZoom(point, 18)
            // 鼠标缩放
            this.baiduMap.enableScrollWheelZoom(true)
            // 自定义地图风格
            this.baiduMap.setMapStyleV2({
                styleId: 'f777ad06a4dddfd871babac841e6a7a4',
            })
            // this.setMessageOpts()
            // this.setMaker()
        },
        // 创建窗口信息（点击触发）
        setMessageOpts: function () {
            let _this = this
            let opts = {
                width: 230,
                height: 10,
                title: '',
                enableMessage: true,
            }
            function openInfo(content, e) {
                let p = e.target
                let point = new BMap.Point(
                    p.getPosition().lng,
                    p.getPosition().lat
                )
                let infoWindow = new BMap.InfoWindow(content, opts) //创建窗口对象
                _this.baiduMap.openInfoWindow(infoWindow, point) //开启窗口信息
            }
            // 点击触发信息窗口
            function addClickHandler(content, maker) {
                maker.addEventListener('click', function (e) {
                    openInfo(content, e)
                })
            }
            let data_info = [] //用来存放窗口信息
            if (_this.mapData.length > 0) {
                //mapData是接口传过来的数据，以下根据mapData数据格式进行处理,存放在data_info中
                for (let i = 0; i < this.mapData.length; i++) {
                    data_info.push([
                        `${this.mapData[i].latitude}`,
                        `${this.mapData[i].longitude}`,
                        `${this.mapData[i].name}` +
                            '</br></br>报抽：' +
                            `${this.mapData[i].bcNumber}` +
                            '&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp报修：' +
                            `${this.mapData[i].bxNumber}`,
                        `${this.mapData[i].name}`,
                    ])
                }
            } else {
                console.log('mapData为空或没有返回')
            }
            this.baiduMap.clearOverlays()
            //添加标注和信息
            for (let i = 0; i < data_info.length; i++) {
                let pt = new BMap.Point(data_info[i][1], data_info[i][0])
                // let lpt = new BMapGL.Point(data_info[i][1], data_info[i][0])
                // 创建文本标注
                let label = new BMap.Label(data_info[i][3], {
                    position: pt,
                    offset: new BMap.Size(-20, -50),
                })
                label.setStyle({
                    color: 'white',
                    border: '0',
                    fontSize: '12px',
                    background: 'rgba(0,0,0,0)',
                    // opacity: '0.1'
                })
                let marker = new BMap.Marker(pt) //创建标注
                // console.log(data_info[i][0])
                let content = data_info[i][2]
                addClickHandler(content, marker)
                _this.baiduMap.addOverlay(label)
                _this.baiduMap.addOverlay(marker)
            }
        },
        clearMaker() {
            this.baiduMap.clearOverlays()
        },
        setMaker() {
            let _this = this
            this.maker = [
                {
                    center: { lng: 117.560471, lat: 31.999984 },
                    zoom: 10,
                    show: true,
                    dragging: true,
                    msg: '海客谈瀛洲',
                },
                {
                    center: { lng: 117.174438, lat: 32.286111 },
                    zoom: 10,
                    show: true,
                    dragging: true,
                    msg: '江山如画',
                },
                {
                    center: { lng: 117.036261, lat: 31.732638 },
                    zoom: 10,
                    show: true,
                    dragging: true,
                    msg: '笑傲江湖',
                },
            ]
            this.baiduMap.clearOverlays()
            this.maker.forEach((item) => {
                //创建自定义标注
                let pt = new BMap.Point(item.center.lng, item.center.lat)
                let myIcon = new BMap.Icon(
                    require('../../assets/image/index/churk.png'),
                    new BMap.Size(24, 28)
                )
                let marker2 = new BMap.Marker(pt) // 创建标注
                // 将标注添加到地图中
                let opts = {
                    width: 200,
                    height: 100,
                    title: '抽粪车辆信息',
                    enableMessage: true,
                    message: '',
                }
                let infoWindow = new BMap.InfoWindow(item.msg, opts)
                marker2.addEventListener('click', function () {
                    _this.baiduMap.openInfoWindow(infoWindow, pt)
                })
                this.baiduMap.addOverlay(marker2)
            })
        },
        // 报修满意度环形图
        dealBxMydAllData(val) {
            let echarts = require('echarts')
            for (let i = 1; i <= 2; i++) {
                let myChart = echarts.init(
                    document.getElementById('bxmyd-pie' + i)
                )
                myChart.clear()
                let that = this
                var option = {
                    title: {
                        text: '',
                        textStyle: {
                            fontWeight: 'normal',
                            color: '#fff',
                        },
                    },
                    color: ['#4CD0DD', '#DF86F0'],
                    tooltip: {
                        trigger: 'item',
                        formatter: function (params) {
                            let tip = ''
                            if (
                                (params.data.name == '不满意' &&
                                    params.data.value == 100) ||
                                (params.data.name == '满意' &&
                                    params.data.value == 0)
                            ) {
                                tip = '暂无评价'
                            } else {
                                tip =
                                    params.data.name +
                                    ':' +
                                    params.data.value +
                                    '%'
                            }
                            return tip
                        },
                    },
                    series: [
                        {
                            name: '',
                            type: 'pie',
                            radius: ['50%', '75%'],
                            data: that.bxMydData[i - 1],
                            label: {
                                show: true,
                                color: '#fff',
                                formatter: function (value) {
                                    let temp = value.data
                                    let str = ''
                                    if (temp.name === '满意') {
                                        str =
                                            temp.name + '\n' + temp.value + '%'
                                    }
                                    return str
                                },
                                position: 'center',
                            },
                            itemStyle: {},
                        },
                    ],
                }
                myChart.on('click', function (param) {
                    // 绑定跳转可视化界面
                    // that.goToVisualization(param.data.bcbxflag, param.data.dayType);
                })
                myChart.setOption(option)
            }
        },
        // 报抽/报修柱状图数据
        dealMydData(val) {
            let echarts = require('echarts')
            let myChart = echarts.init(document.getElementById('myd-echarts'))
            myChart.clear()
            let that = this
            let tempData = [] // 横坐标名称
            let tempBarData = [] // 柱状图数据
            if (val === 'bc') {
                tempData = that.bcBarTitle
                tempBarData = that.bcBarData
            } else {
                tempData = that.bxBarTitle
                tempBarData = that.bxBarData
            }
            var option = {
                tooltip: {
                    trigger: 'item',
                    formatter: function (params) {
                        let tip = ''
                        if (
                            (params.data.name == '不满意' &&
                                params.data.value == 100) ||
                            (params.data.name == '满意' &&
                                params.data.value == 0)
                        ) {
                            tip = '暂无评价'
                        } else {
                            tip =
                                params.data.name + ':' + params.data.value + '%'
                        }
                        return tip
                    },
                },
                series: [
                    {
                        name: val == 'bc' ? '报抽' : '报修',
                        type: 'bar',
                        data: tempBarData,
                        itemStyle: {
                            normal: {
                                //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                                color: new echarts.graphic.LinearGradient(
                                    0,
                                    1,
                                    0,
                                    0,
                                    [
                                        {
                                            offset: 0,
                                            color: '#37a2da',
                                        },
                                        {
                                            offset: 1,
                                            color: '#67e0e3',
                                        },
                                    ]
                                ),
                            },
                        },
                    },
                ],
            }
            option.xAxis = {
                type: 'category',
                data: tempData,
                axisLine: {
                    lineStyle: {
                        color: '#ffffff',
                    },
                },
                axisLabel: {
                    interval: 0,
                    showMaxLabel: true,
                    formatter: function (value) {
                        // 让x轴字体垂直显示;如果柱形图x轴的信息太长会出现显示不全或者信息重叠在一起
                        let str = ''
                        let maxLength = 3
                        let valLength = value.length
                        console.log(value)
                        let rowN = Math.ceil(valLength / maxLength)
                        if (rowN > 1) {
                            for (let i = 0; i < rowN; i++) {
                                let temp = ''
                                let start = i * maxLength
                                let end = start + maxLength
                                temp = value.substring(start, end) + '\n'
                                str += temp
                            }
                            return str
                        } else {
                            return value
                        }
                    },
                    textStyle: {
                        fontSize: 14,
                    },
                    // interval: -1, // 横轴信息全部显示
                    // rotate: -30 // -15度角倾斜显示
                },
            }
            option.yAxis = {
                // min: 0,
                // max: 100,
                // interval: 25,
                axisLine: {
                    lineStyle: {
                        color: '#ffffff',
                    },
                },
            }
            // myChart.on('click',function (param) {
            //     // 绑定跳转可视化界面
            //     that.goToVisualization(param.data.bcbxflag, param.data.dayType);
            // })
            myChart.setOption(option)
        },
        // 报抽报修滚动列表切换
        changeDataClass: function (type) {
            if (type === 'bx') {
                this.dataClass = 'bx'
                this.listTitle = '报修数据'
                this.getBxData('')
                this.$message.success('已切换报修数据！')
                this.bcBtnTitle = '(全部)'
            } else {
                this.dataClass = 'bc'
                this.listTitle = '报抽数据'
                this.getBcData('')
                this.$message.success('已切换报抽数据！')
                this.bcBtnTitle = '(全部)'
            }
        },
        // 滚动列表数据切换
        changeDataType: function (flag, type) {
            if (flag === 'all') {
                this.bcBtnTitle = '(全部)'
                if (type === 'bc') {
                    this.bcfw = ''
                    this.getBcData('')
                } else {
                    this.bxfw = ''
                    this.getBxData('')
                }
            } else if (flag === 'month') {
                this.bcBtnTitle = '(当月)'
                if (type === 'bc') {
                    this.bcfw = '1'
                    this.getBcData('2')
                } else {
                    this.bxfw = '1'
                    this.getBxData('2')
                }
            } else {
                this.bcBtnTitle = '(当日)'
                if (type === 'bc') {
                    this.bcfw = '2'
                    this.getBcData('5')
                } else {
                    this.bxfw = '2'
                    this.getBxData('5')
                }
            }
        },
        // 柱状图数据切换
        changeBarType: function (type) {
            this.barTitle = type === 'bc' ? '报抽' : '报修'
            this.dealMydData(type)
        },
        returnXZname: function (i, type) {
            if (type === 'bc') {
                return this.bcMydData.length > 0
                    ? this.bcMydData[i - 1][0].xzName
                    : ''
            } else {
                return this.bxMydData.length > 0
                    ? this.bxMydData[i - 1][0].xzName
                    : ''
            }
        },
        getClInfo: function () {
            let _this = this
            let param = {}
            param.baseService = 'TGcBcxxServiceImpl'
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                _this.GLOBAL.config.handleType.getclInfo,
                param,
                null,
                (resultData) => {
                    _this.loading = false
                    if (resultData) {
                        let list = []
                        resultData.obj.map((item) => {
                            let { xm, sjh, cph, rwsl, wcsl, yjsl } = item
                            list.push([
                                xm,
                                sjh,
                                cph,
                                rwsl ? rwsl : '0',
                                wcsl ? wcsl : '0',
                                yjsl ? yjsl : '0',
                            ])
                        })
                        _this.clConfig = {
                            ..._this.clConfig,
                            data: list,
                        }
                    } else {
                        _this.$message.warning('获取数据失败～')
                    }
                },
                () => {
                    _this.loading = false
                }
            )
        },
        // 总数统计请求
        getAllData: function () {
            let _this = this
            let param = {}
            param.baseService = 'TGcBcxxServiceImpl'
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                _this.GLOBAL.config.handleType.totalbcbxNum,
                param,
                null,
                (resultData) => {
                    _this.loading = false
                    if (resultData) {
                        _this.numData.bcAll = resultData.obj.totalbc
                        _this.numData.ycAll = resultData.obj.totalyBc
                        _this.numData.bxAll = resultData.obj.totalbx
                        _this.numData.yxAll = resultData.obj.totalyBx
                        _this.$refs.flop.init(_this.numData)
                    } else {
                        _this.$message.warning('获取数据失败～')
                    }
                },
                () => {
                    _this.loading = false
                }
            )
        },
        // 地图数据组装
        dealMapData: function (list, type) {
            let _this = this
            if (type === 'bc') {
                list.forEach((item) => {
                    _this.mapData.forEach((child) => {
                        if (item.name === child.name) {
                            child.bcNumber = item.rwslNumbers
                        }
                    })
                })
            } else {
                list.forEach((item) => {
                    _this.mapData.forEach((child) => {
                        if (item.name === child.name) {
                            child.bxNumber = item.rwslNumbers
                        }
                    })
                })
            }
        },
        // 报抽滚动数据
        getBcData: function (type) {
            let _this = this
            let param = {}
            param.type = type
            param.flag = '1'
            param.baseService = 'TGcBcxxServiceImpl'
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                _this.GLOBAL.config.handleType.getBsxzBxSummary,
                param,
                null,
                (resultData) => {
                    _this.loading = false
                    if (resultData) {
                        _this.bcBarData = []
                        _this.bcBarTitle = []
                        let { obj } = resultData
                        let list = []
                        _this.dealMapData(obj, 'bc')
                         _this.bcsddata=resultData.obj
                        obj.map((item) => {
                            let {
                                shortName,
                                gchsNumbers,
                                rwslNumbers,
                                wcNumbers,
                                csNumbers,
                                code,
                            } = item
                            list.push([
                                shortName,
                                gchsNumbers,
                                rwslNumbers,
                                wcNumbers,
                                csNumbers,
                            ])
                            _this.xzList.push({
                                xzName: shortName,
                                xzCode: code,
                            })
                            // 柱状图
                            _this.bcBarData.push({
                                name: shortName,
                                value: rwslNumbers,
                            })
                            _this.bcBarTitle.push(shortName)
                        })
                        _this.bcConfig = {
                            ..._this.bcConfig,
                            data: list,
                        }
                        if (_this.barFlag == false) {
                            _this.barFlag = true
                            // 报抽柱状图
                            _this.dealMydData('bc')
                        }
                    } else {
                        _this.$message.warning('获取数据失败～')
                    }
                },
                () => {
                    _this.loading = false
                }
            )
        },
        // 报修滚动数据
        getBxData: function (type) {
            let _this = this
            let param = {}
            param.type = type
            param.flag = '2'
            param.baseService = 'TGcBcxxServiceImpl'
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                _this.GLOBAL.config.handleType.getBsxzBxSummary,
                param,
                null,
                (resultData) => {
                    _this.loading = false
                    if (resultData) {
                      _this.bxsddata=resultData.obj.list
                        _this.bxBarData = []
                        _this.bxBarTitle = []
                        let { obj } = resultData
                        _this.dealMapData(obj, 'bx')
                        _this.bcsddata=resultData.obj
                        let list = []
                        obj.map((item) => {
                            let {
                                shortName,
                                gchsNumbers,
                                rwslNumbers,
                                wcNumbers,
                                csNumbers,
                            } = item
                            list.push([
                                shortName,
                                gchsNumbers,
                                rwslNumbers,
                                wcNumbers,
                                csNumbers,
                            ])
                            // 柱状图
                            _this.bxBarData.push({
                                name: shortName,
                                value: rwslNumbers,
                            })
                            _this.bxBarTitle.push(shortName)
                        })
                        _this.bxConfig = {
                            ..._this.bxConfig,
                            data: list,
                        }
                    } else {
                        _this.$message.warning('获取数据失败～')
                    }
                },
                () => {
                    _this.loading = false
                }
            )
        },
        // 满意度环状图数据请求
        getMydData: function (type) {
            let _this = this
            let param = {}
            param.baseService = 'TGcBcxxServiceImpl'
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                _this.GLOBAL.config.handleType.getBsxzmyd,
                param,
                null,
                (resultData) => {
                    _this.loading = false
                    if (resultData) {
                        // 满意度
                        _this.makeMydData(resultData.obj)
                    } else {
                        _this.$message.warning('获取数据失败～')
                    }
                },
                () => {
                    _this.loading = false
                }
            )
        },
        // 满意度数据组装
        makeMydData: function (obj) {
            let _this = this
            let bx = obj.bx
            let bc = obj.bc
            if (bc == null) {
                bc = 0
            }
            _this.bxMydData.push([
                {
                    name: '满意',
                    value: parseInt(bc),
                },
                {
                    name: '不满意',
                    value: 100 - parseInt(bc),
                },
            ])
            if (bx == null) {
                bx = 0
            }
            _this.bxMydData.push([
                {
                    name: '满意',
                    value: parseInt(bx),
                },
                {
                    name: '不满意',
                    value: 100 - parseInt(bx),
                },
            ])
            _this.dealBxMydAllData()
        },
        // 跳转可视化界面
        goToVisualization(bcbxflag, code, dayType) {
            this.$router.push({
                name: 'VisualizationTableXZ',
                params: {
                    type: 'view',
                    visualization: {
                        bcbxflag: bcbxflag,
                        code: code,
                        dayType: dayType,
                    },
                },
            })
        },

        listCellClick(obj) {
            if (this.dataClass === 'bc') {
                this.bcCellClick(obj)
            } else {
                this.bxCellClick(obj)
            }
        },
        listCellClickn(row, column, event){
          if (this.dataClass === 'bc') {
              // this.bcCellClick(obj)
               this.goToVisualization('1', row.code, this.bcfw)
          } else {
              // this.bxCellClick(obj)
              this.goToVisualization('3', row.code, this.bxfw)
          }
        },
        bcCellClick(obj) {
            console.log(obj)
            let { rowIndex, row } = obj
            let xzName = row[0]
            let code = ''
            this.xzList.forEach((item) => {
                if (xzName == item.xzName) {
                    code = item.xzCode
                }
            })
            this.goToVisualization('1', code, this.bcfw)
        },
        bxCellClick(obj) {
            console.log(obj)
            let { rowIndex, row } = obj
            let xzName = row[0]
            let code = ''
            this.xzList.forEach((item) => {
                if (xzName == item.xzName) {
                    code = item.xzCode
                }
            })
            this.goToVisualization('3', code, this.bxfw)
        },
        // bcCellClickn(row, column, event){
        //   this.goToVisualization('1', row.code, this.bcfw)
        // },
        // bxCellClickn(row, column, event){
        //   this.goToVisualization('3', row.code, this.bcfw)
        // },
        cellClick(obj) {
            let { rowIndex } = obj
            this.RowData = this.warningData[rowIndex]
            setTimeout(() => {
                this.showState = true
            }, 800)
        },
    },
    computed: {
        ...mapGetters({ warningData: 'common/warningData' }),
    },
    watch: {
        $route(to, from) {
            if (from.name === 'VisualizationTableXZ') {
                let _this = this
                this.barFlag = false
                this.getAllData()
                this.getClInfo()
                this.getBcData('')
                this.getBxData('')
                this.getMydData()
                // setTimeout(function () {
                //     _this.createMap()
                // }, 1000)
                this.getWarningData()
            }
        },
        showState(n, o) {
            if (!n) {
                this.$parent.getWarningList()
            }
        },
        warningData(n, o) {
            this.config = {
                ...this.config,
                data: n.map((item) => [
                    item['yjCl'],
                    item['ssxzmc'],
                    item['sjXm'],
                    item['sjPhone'],
                    item['yjTime'],
                ]),
            }
        },
    },
}
</script>

<style scoped lang="scss">
.zName {
    font-size: 14px;
    text-align: center;
}
.anchorBL {
    display: none;
}
.BMap_cpyCtrl {
    display: none;
}
.main {
    width: 100%;
    height: 65%;
    display: flex;
    /*margin-top: 20px;*/
}
.main-left {
    width: 35%;
    height: 100%;
    min-width: 350px;
}
.main-middle {
    width: 30%;
    height: 100%;
    /* border: 1px solid red; */
}
.main-right {
    width: 35%;
    height: 100%;
    min-width: 350px;
}
.charts-space {
    height: 100%;
}
.cc-echarts {
    width: 100%;
    height: calc(100% - 30px);
    /*border: 2px solid blue;*/
    margin-bottom: 20px;
    border-radius: 20px;
    /*padding-top: 5px;*/
    padding-left: 5px;
}
#data-view {
    width: 100%;
    height: 100%;
    background-color: #030409;
    color: #fff;

    #dv-full-screen-container {
        background-size: 100% 100%;
        box-shadow: 0 0 3px blue;
        display: flex;
        flex-direction: column;
    }

    .main-content {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .block-left-right-content {
        flex: 1;
        display: flex;
        margin-top: 20px;
    }

    .block-top-bottom-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding-left: 20px;
    }

    .block-top-content {
        height: 55%;
        display: flex;
        flex-grow: 0;
        box-sizing: border-box;
        padding-bottom: 20px;
    }
}
#rose-chart {
    width: 30%;
    height: 100%;
    background-color: rgba(6, 30, 93, 0.5);
    border-top: 2px solid rgba(1, 153, 209, 0.5);
    box-sizing: border-box;

    .rose-chart-title {
        height: 50px;
        font-weight: bold;
        text-indent: 20px;
        font-size: 20px;
        display: flex;
        align-items: center;
    }

    .dv-charts-container {
        height: calc(100% - 50px);
    }
}
.map {
    width: 100%;
    height: 100%;
}
.map-space {
    height: calc(100% - 120px);
    width: 90%;
    margin-top: 20px;
    margin-left: 5%;
    /*padding-bottom: 10px;*/
    /*margin-top: 20px;*/
}

.showWarningBox {
    padding: 14px 0 !important;
}

.showWarningBox .el-table__header {
    width: 100% !important;
}

.showWarningBox .el-table__body {
    width: 100% !important;
}

.showWarningBox .el-notification__title {
    color: #e6a23c !important;
}
// 手动滚动 -->

.el-table /deep/ .warning-row{
	  background:rgb(10,39,50);
    color:#FFFFFF;
}
.el-table /deep/ .info-row{
	  background: rgb(0, 59, 81);
    color:#FFFFFF;
}


.border-table /deep/ th{
     border:none;
}
.border-table /deep/ td,.border-table  /deep/ th.is-leaf {
  border:none;
}
.border-table{
  border: none;
}

.border-table .el-table--border::after,.border-table .el-table--group::after{
     width: 0;
   }
.border-table::before{
  width: 0;
}
.border-table .el-table__fixed-right::before,.el-table__fixed::before{
  width: 0;
}
.border-table .el-table__header tr th{

  border: 0px;

}
// 滚动条
// .el-table /deep/ .el-table__body-wrapper::-webkit-scrollbar{
//     display: none;
//   }
.el-table /deep/ .el-table__body-wrapper::-webkit-scrollbar {
// width: 7px; /*滚动条宽度*/
height: 4px; /*滚动条高度*/
background-color: rgb(10,39,50);
}

// /*定义滑块 内阴影+圆角*/
.el-table /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
background-color: rgba(0, 59, 81,1) /*滚动条的背景颜色*/
}
.charts-space /deep/  .el-table, .el-table__expanded-cell {
    background-color: transparent;
}
.charts-space /deep/  .el-table .gutter {
    width: 0;
    background-color:transparent;
}
 .el-table /deep/ .el-table__body tr:hover>td {
		background-color: #134087 !important;
	}
</style>



// WEBPACK FOOTER //
// src/view/PrefectureScreen/PrefectureScreenXZ.vue